<div class="editor-choice-tracks__cards">
  @for (track of tracks; track track) {
    <bmcore-track-item-box class="editor-choice-tracks__item" [track]="track" [tracks]="tracks">
    </bmcore-track-item-box>
  }
</div>

<div class="editor-choice-tracks__slider">
  <bmcore-common-slider [tracks]="tracks"></bmcore-common-slider>
</div>
